import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';

export interface IList {
  id: number | string;
  text: string;
  select?: boolean;
  visible?: boolean;
  type: number | string;
}

@Component({
  selector: 'ubl-select-list',
  templateUrl: './template.html',
  styleUrls: ['./styles.scss']
})
export class SelectListComponent implements OnInit {
  public mostrarError: boolean;
  public messageOneRegular: string;
  @Input() data: IList[] = [];
  @Input() control: FormControl = new FormControl([]);


  ngOnInit(): void { }

  public _getData(select: boolean = true, input: Input): IList[] {

    if (this.data) {
      return this.data.filter(field => {
        if (field.select === select) {
          return field.text.toUpperCase().includes(input['value'].toUpperCase() || '');
        }
        return false;
      });
    }
    return [];

  }
  private _loadData() {

    this.control.setValue(this.data.filter(field => field.select).map((value: IList) => value.id));
  }

  private _select(item) {
    this.mostrarError = false;
    if (item.type == 1 && !item.select) { //valido si es un tipo de horario regular
      let hayRegular = this.data.filter(field => field.select).filter((item) => { return item.type == 1 });
      if (hayRegular.length >= 1) {
        this.mostrarError = true;
        this.messageOneRegular = "Ya existe un horario regular asignado '" + hayRegular[0].text + "' , no puede asignar mas de 1 horario regular";
      } else {
        item.select = !item.select;
        this._loadData();
      }
    } else {
      item.select = !item.select;
      this._loadData();
    }

  }

}



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/shared/component/list-filter/select.list.component.ts